const PERCENTAGE_ENUM = ['percentage', 'porcentagem']
const isPercentage = value => PERCENTAGE_ENUM.includes(value.toLowerCase())

export { PERCENTAGE_ENUM, isPercentage }
